import { fetchData } from 'modules/Axios';
import { notifyFailure } from 'modules/Notifications';

export const defaultState = {
  currentTab: 'EXPORTS',
  stats: null,
  statsCsvLink: null,
};

export const TOGGLE_TAB = 'TOGGLE_TAB';
export const toggleTab = (payload) => ({ type: TOGGLE_TAB, payload });

export const RESET_ROUTE_DATA = 'RESET_ROUTE_DATA';
export const resetRouteData = () => ({ type: RESET_ROUTE_DATA });

export const RECEIVE_CSV_STATS_LINK = 'RECEIVE_CSV_STATS_LINK';
export const receiveCsvStatsLink = (link) => ({ type: RECEIVE_CSV_STATS_LINK, payload: link });

export const GET_CVS_STATS = 'GET_CVS_STATS';
export const getCsvLinkStats = (queryParam) => {
  return async (dispatch, getState) => {
    const { brand } = getState().app;
    const URL = `/brands/${brand.id}/audiences/stats/onboarded-by-destinations/download${queryParam}`;
    try {
      const data = await dispatch(fetchData(URL, {}, {}, false, 'text'));
      return data;
    } catch (e) {
      console.error('API Call to /audiences/stats/onboarded-by-destinations failed...', e);
      notifyFailure('Failed to retrieve admin stats');
      return { data: [] };
    }
  };
};

export const RECEIVE_EXPORTS_STATS = 'RECEIVE_EXPORTS_STATS';
export const receiveExportsStats = (payload) => ({ type: RECEIVE_EXPORTS_STATS, payload });

export const getStats = () => {
  return async (dispatch, getState) => {
    const { brand } = getState().app;
    const URL = `/brands/${brand.id}/audiences/stats/onboarded-by-destinations`;
    try {
      const stats = await dispatch(fetchData(URL));
      dispatch(receiveExportsStats(stats));
    } catch (e) {
      console.error('API Call to /audiences/stats/onboarded-by-destinations failed...', e);
      notifyFailure('Failed to retrieve admin stats');
      dispatch(receiveExportsStats(defaultState.stats));
    }
  };
};

export default function reducer(state = defaultState, action = undefined) {
  switch (action.type) {
    case RECEIVE_EXPORTS_STATS:
      return {
        ...state,
        stats: action.payload,
      };
    case RESET_ROUTE_DATA:
      return {
        ...defaultState,
        currentTab: state.currentTab,
      };
    case TOGGLE_TAB:
      return {
        ...state,
        currentTab: action.payload,
      };
    default:
      return state;
  }
}
